import { isDevToolboxEnabled } from "@/lib/devToolbox/isDevToolboxEnabled";
import {
  buildDevPurchaseDetailsView,
  DEV_TOOLBOX_PURCHASE_MOCK_ID,
} from "@/lib/devToolbox/buyerTransactionMocks";

export { DEV_TOOLBOX_PURCHASE_MOCK_ID } from "@/lib/devToolbox/buyerTransactionMocks";

export function isDevToolboxPurchaseMock(purchaseId: string): boolean {
  return isDevToolboxEnabled() && purchaseId === DEV_TOOLBOX_PURCHASE_MOCK_ID;
}

export function resolveDevPurchaseMockDetails(purchaseId: string) {
  if (!isDevToolboxPurchaseMock(purchaseId)) return null;
  return buildDevPurchaseDetailsView("pending");
}
